import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { SharedStateProvider } from "state";
import { ReactNotifications } from "react-notifications-component";
import "assets/js/demo.js";
import "assets/js/tabler.js";
import "assets/css/demo.css";
import "assets/css/tabler.css";
import "assets/css/tabler-social.css";
import "assets/css/tabler-vendors.css";
import "index.css";
import "react-notifications-component/dist/theme.css";
import "animate.css/animate.min.css";
import reportWebVitals from "./reportWebVitals";
import NavbarLayout from "components/layout";
import TasksPage from "pages/tasks";
import NewTask from "pages/tasks/new";
import TaskDetail from "pages/tasks/detail";
import DocumentsPage from "pages/documents";
import NewDocument from "pages/documents/new";
import DocumentDetail from "pages/documents/detail";
import PaymentsPage from "pages/payments";
import NewPayment from "pages/payments/new";
import PaymentDetail from "pages/payments/detail";
import Budgets from "pages/budgets";
import NewBudget from "pages/budgets/new";
import Reports from "pages/reports";
import NewReport from "pages/reports/new";
import Users from "pages/users";
import NewUser from "pages/users/new";
import Departments from "pages/users/departments";
import Positions from "pages/templates/positions";
import Locations from "pages/templates/locations";
import Companies from "pages/templates/companies";
import Templates from "pages/templates";
import Contractors from "pages/contractors";
import NewContractor from "pages/contractors/new";
import Levels from "pages/levels";
import NewLevel from "pages/levels/new";
import Codes from "pages/codes";
import NewCode from "pages/codes/new";
import Formulas from "pages/formulas";
import NewFormula from "pages/formulas/new";
import Constructor from "pages/constructor";
import NewReportTemplate from "pages/constructor/new";
import NewTemplate from "pages/templates/new";
import BudgetTypes from "pages/templates/budget-types";
import ProtectedRoute from "components/protected-route";
import ForbiddenPage from "components/protected-route/forbidden";

const App = () => {
  return (
    <Router>
      <SharedStateProvider>
        <Routes>
          <Route path="/" element={<NavbarLayout />}>
            <Route index element={<Navigate to="/tasks" replace={true} />} />

            <Route path="forbidden" element={<ForbiddenPage />} />

            <Route path="tasks" element={<TasksPage />}>
              <Route path="create" element={<NewTask />} />
              <Route path=":taskId" element={<TaskDetail />} />
            </Route>

            <Route
              path="documents"
              element={
                <ProtectedRoute accessPage="documents">
                  <DocumentsPage />
                </ProtectedRoute>
              }
            >
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="documents">
                    <NewDocument />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":documentId"
                element={
                  <ProtectedRoute accessPage="documents">
                    <DocumentDetail />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="payments"
              element={
                <ProtectedRoute accessPage="payments">
                  <PaymentsPage />
                </ProtectedRoute>
              }
            >
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="payments">
                    <NewPayment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":paymentId"
                element={
                  <ProtectedRoute accessPage="payments">
                    <PaymentDetail />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="budgets"
              element={
                <ProtectedRoute accessPage="budgets">
                  <Budgets />
                </ProtectedRoute>
              }
            >
              <Route
                path=":budgetId"
                element={
                  <ProtectedRoute accessPage="budgets">
                    <NewBudget />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="budgets">
                    <NewBudget />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="reports"
              element={
                <ProtectedRoute accessPage="budgets">
                  <Reports />
                </ProtectedRoute>
              }
            >
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="budgets">
                    <NewReport />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="users"
              element={
                <ProtectedRoute accessPage="admin">
                  <Users />
                </ProtectedRoute>
              }
            >
              <Route
                path=":userId"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="departments"
                element={
                  <ProtectedRoute accessPage="admin">
                    <Departments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewUser />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="templates"
              element={
                <ProtectedRoute accessPage="admin">
                  <Templates />
                </ProtectedRoute>
              }
            >
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewTemplate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="positions"
                element={
                  <ProtectedRoute accessPage="admin">
                    <Positions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="locations"
                element={
                  <ProtectedRoute accessPage="admin">
                    <Locations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="companies"
                element={
                  <ProtectedRoute accessPage="admin">
                    <Companies />
                  </ProtectedRoute>
                }
              />
              <Route
                path="budget-list"
                element={
                  <ProtectedRoute accessPage="admin">
                    <BudgetTypes />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="contractors"
              element={
                <ProtectedRoute accessPage="admin">
                  <Contractors />
                </ProtectedRoute>
              }
            >
              <Route
                path=":contractorId"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewContractor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewContractor />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="levels"
              element={
                <ProtectedRoute accessPage="admin">
                  <Levels />
                </ProtectedRoute>
              }
            >
              <Route
                path=":levelId"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewLevel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewLevel />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="codes"
              element={
                <ProtectedRoute accessPage="admin">
                  <Codes />
                </ProtectedRoute>
              }
            >
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewCode />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="formulas"
              element={
                <ProtectedRoute accessPage="admin">
                  <Formulas />
                </ProtectedRoute>
              }
            >
              <Route
                path=":formulaId"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewFormula />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewFormula />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="constructor"
              element={
                <ProtectedRoute accessPage="admin">
                  <Constructor />
                </ProtectedRoute>
              }
            >
              <Route
                path=":templateId"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewReportTemplate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute accessPage="admin">
                    <NewReportTemplate />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>
        </Routes>
      </SharedStateProvider>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ReactNotifications />
    <App />
  </React.StrictMode>
);

reportWebVitals();
